module.exports = {
  lang: "简体中文",
  home: "首页",
  AboutIPO: "关于",
  SubmitIPO: "众筹",
  Submit: "提交",
  Login: "登录",
  Logout: "退出",
  Start: "开始时间",
  Ending: "预期结束时间",
  End: "结束时间",
  Search: "搜索",
  Project: "项目",
  Token: "代币",
  Locked: "锁定",
  LockedCap: "锁定/总数",
  Raised: "Raised",
  RaisedCap: "Raised/Cap",
  Leases: "租期",
  Contribute: "参与",
  Title: "项目名称",
  ParaID: "ParaID",
  Owner: "发起人",
  Rewards: "奖励",
  TokenSymbol: "代币名称",
  RewardsInformation: "奖励信息",
  RewardsInformationURL: "奖励信息公开公告网址",
  Records: "记录",
  ExtrinsicHash: "交易哈希",
  Amount: "数量",
  DateTime: "时间",
  More: "更多",
  Withdraw: "提现",
  noMathExtension: "请先连接麦子钱包扩展程序",
  noAddress: "请切换到 %W 钱包操作",
  noAccount: "暂无账户",
  SelectAccount: "选择账户",
  ViewDetails: "查看详细信息",
  NoInfo: "暂无数据",
  backToHome: "返回首页",
  EnterAmountFirst: "请输入数量",
  noOwner: "请输入拥有者",
  noParaID: "请输入 ParaID",
  noTokenSymbol: "请输入代币",
  noRewardsInformation: "请输入奖励信息",
  noRewardsInformationURL: "请输入奖励信息公开公告网址",
  APR: "年化收益",
  SlotAuction: "竞拍",
  Auction: "竞拍",
  LogInMathWallet: "通过 MathWallet 登录",
  LogInPolkadotJS: "通过 PolkadotJS 登录",
  SelectLoginAccount: "选择一个插件钱包登录",
  days: " 天 ",
  day: " 天 ",
  hrs: " 小时 ",
  hr: " 小时 ",
  mins: " 分钟 ",
  min: " 分钟 ",
  s: " 秒 ",
  amountNotenough: "可用余额不足",
  available: "可用余额",
  Rewards_tip1: "奖励信息公开公告",
  Rewards_tip2: "更多项目信息",
};
